const GTM_SCRIPT_ID = 'acerto-gtm';

/**
 * Injeta o Google Tag Manager. Só deve ser chamado com consentimento concedido (opt-in): ao
 * carregar, o GTM processa tudo o que já estiver no `dataLayer`.
 */
export function carregarGtm(): void {
  if (document.getElementById(GTM_SCRIPT_ID)) return;

  const gtmId = appSettings.VUE_APP_GTM_CODE;
  if (!gtmId) {
    logger.warn('GTM não carregado: VUE_APP_GTM_CODE não configurado.');
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
  document.head.appendChild(script);
}
